import React, { useState, useEffect, useRef } from 'react'
import 'antd/lib/style/index.css'
import zhCN from 'antd/lib/locale/zh_CN'
import css from './user-center.module.less'
import {
  Card,
  ConfigProvider,
  Modal,
  Button,
  Radio,
  Upload,
  message,
  Row,
  Col,
  Input,
} from 'antd'

import { sendHttpPostRequest } from '../../../api/http-request'
import type { DraggableData, DraggableEvent } from 'react-draggable'

import { BACKEND_API_URL } from '../../../constants/constants'

import Draggable from 'react-draggable'
import Cookies from 'js-cookie'

interface Props {}


export const MyBasicInfo: React.FC<Props> = (props: Props) => {
  const [pwdModalVisible, setPwdModalVisible] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const draggleRef = useRef<HTMLDivElement>(null)

  const [userInfo, setUserInfo] = useState( {} as any) // 完整用户信息
  const [nickName, setNickName] = useState('') // 昵称
  const [realName, setRealName] = useState('') // 真实姓名
  const [introduction, setIntroduction] = useState('') // 个人简介
  const [sex, setSex] = useState(1) // 性别  1-未设置（默认） 2-男  3-女
  const [sexLabel, setSexLabel] = useState('') // 性别 未设置 男 女
  const [isUserLogin, setIsUserLogin] = useState(false) // 用户登录状态
  const [userHeaderImg, setUserHeaderImg] = useState('') // 用户头像
  const [editMode, setEditMode] = useState(false)

  const currentPwd = useRef('') // 当前密码
  const newPwd = useRef('') // 新密码
  const newPwdConfirm = useRef('') // 新密码确认

  const [imgFileList, setImgFileList] = useState([] as any)

  useEffect(() => {
    queryUserInfo()
    return () => {}
  }, [])

  const pwdChangeClick = () => {
    setPwdModalVisible(true)
  }

  const onOkToChangePwd = (e: React.MouseEvent<HTMLElement>) => {
    if (currentPwd.current.trim() == '') message.error('请输入当前密码')
    else if (currentPwd.current.length < 6 || currentPwd.current.length > 20)
      message.error('当前密码长度6-20位')
    else if (newPwd.current.trim() == '') {
      if (newPwd.current.length > 0) message.error('新密码不能都是空格')
      else message.error('请输入新密码')
    } else if (newPwdConfirm.current.trim() == '')
      message.error('请输入新密码确认')
    else if (newPwdConfirm.current != newPwd.current)
      message.error('两次输入的新密码输入不一致')
    else if (newPwdConfirm.current == currentPwd.current)
      message.error('新旧密码不能相同')
    else if (
      newPwdConfirm.current.length < 6 ||
      newPwdConfirm.current.length > 20
    )
      message.error('密码长度6-20位')
    else {
      let _data = {
        current_password: currentPwd.current,
        new_password: newPwd.current,
        new_password_confirm: newPwdConfirm.current,
      }
      const _url = '/account/api/change_password/'
      sendHttpPostRequest( _url, _data,
        (data) => {
          message.destroy()
          if (data.is_ok) {
            setPwdModalVisible(false)

            message.success('密码修改成功，下次登录请使用新密码')
          } else {
            message.error(`密码修改失败：${data.message}`)
          }
        })
  
    }
  }

  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    setPwdModalVisible(false)
  }

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }

  // 调用Confirm框
  const showModal = () => {
    document.getElementById('show-login-modal')!.click()
  }

  /**
   * 获取用户信息
   */
  const queryUserInfo = () => {
    let _data = {}
    const _url = 'account/api/get_user_info/'
    sendHttpPostRequest( _url, _data,
      (data) => {
        data.code == -100 ? showModal() : setIsUserLogin(true)

        if(data.is_ok == true){
          setUserInfo(data.data)
          setRealName(data.data.real_name)
          setNickName(data.data.nick_name)
          setIntroduction(data.data.introduction)
          setSex(data.data.sex_number)
          setSexLabel(data.data.sex)
          setUserHeaderImg(data.data.avatar)
        }else {
          message.error(data?.message)
        }
      })

  }


  const updateUserInfo = () => {
    if (!nickName.trim()) {
      alert('昵称不能为空')
    } else {
      let _data = {
        nick_name: nickName,
        real_name: realName,
        introduction: introduction,
        sex: sex,
      }
      const _url = 'account/api/update_user_info/'
      sendHttpPostRequest( _url,_data,
        (data) => {
          if(data.is_ok){
           
          }
        })
      
    }
  }

  // 昵称改变
  const onNickNameChange = (event) => {
    setNickName(event.target.value.toString())
  }
  // 个人简介改变
  const onIntroductionChange = (event) => {
    setIntroduction(event.target.value.toString())
  }

  // 真实姓名改变
  const onRealNameChange = (event) => {
    setRealName(event.target.value.toString())
  }

  const onSexChange = (event) => {
    setSex(event.target.value)
    if (event.target.value == 2) {
      setSexLabel('男')
    } else if (event.target.value == 3) {
      setSexLabel('女')
    } else {
      setSexLabel('未设置')
    }
  }

  // 改变了当前密码
  const onCurrentPwdChange = (event: any) => {
    currentPwd.current = event.target.value
  }

  // 改变了新密码
  const onNewPwdChange = (event: any) => {
    newPwd.current = event.target.value
  }

  // 改变了新密码确认
  const onNewPwdConfirmChange = (event: any) => {
    newPwdConfirm.current = event.target.value
  }

  const onImageChange = (info: any) => {
    setImgFileList(info.fileList)

    const { status } = info.file
    if (status !== 'uploading') {
      //上传中
      
    }
    if (status === 'done') {
      //上传成功
      let new_avatar = BACKEND_API_URL + info.file.response.img_url
      document.getElementById('user-avatar')!.setAttribute('src', new_avatar)
      document
        .getElementById('header-user-avatar')!
        .setAttribute('src', new_avatar)
        document
        .getElementById('pop-user-avatar')!
        .setAttribute('src', new_avatar)
      document.getElementById('info-avatar')!.setAttribute('src', new_avatar)
    } else if (status === 'error') {
      //上传失败
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  const beforeImageUpload = (file: any) => {
    
    const fileSize = file.size
    const maxSize = 5 * 1024 * 1024
    if (fileSize > maxSize) {
      setImgFileList([])
      message.error('上传文件大于5M,换一个试试呢')
      return false
    } else {
      return true
    }
  }
  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
  }
  const replaceCoverHandler = () => {
    document.getElementById('replace-cover')?.click()
  }

  return (


      <Card
        bodyStyle={{
          color: '#333',
        }}
        style={{

          position: 'relative',
          border:'none'
        }}
      >

        <Row align="middle" justify="start" className={css.row}>
          <Col flex={'216px'}>账号</Col>
          <Col flex={'auto'}>
              <span >{userInfo?.register_type == 1 ? userInfo?.phone : userInfo?.email }</span>
          </Col>
        </Row>

        <Row align="middle" justify="start" className={css.row}>
          <Col flex={'216px'}>昵称</Col>
          <Col flex={'auto'}>
              <span hidden={editMode}>{nickName}</span>
            <Input
              hidden={!editMode}
              value={nickName}
              onChange={onNickNameChange.bind(this)}
              placeholder="请输入昵称（必填）"
            />
          </Col>
        </Row>
        <Row align="top" justify="start" className={css.row}>
          <Col flex={'216px'}>头像</Col>
          {isUserLogin && (
            <Col flex={'auto'}>
              <img
                hidden={editMode}
                className={css.avatar}
                src={BACKEND_API_URL + userHeaderImg}
                alt="头像"
                id="info-avatar"
              />
              <div className={css.imgContain} hidden={!editMode}>
                <Upload
                  action={
                    BACKEND_API_URL + 'account/api/upload_header_image/'
                  }
                  maxCount={1}
                  accept=".jpg,.jpeg,.png"
                  listType="picture-card"
                  name="avatar"
                  fileList={imgFileList}
                  onChange={onImageChange}
                  beforeUpload={beforeImageUpload}
                  data={uploadData}
                  showUploadList={false}
                >
                  <span id="replace-cover"></span>
                  <img
                    id="user-avatar"
                    className={css.avatar}
                    src={BACKEND_API_URL+ userHeaderImg}
                    height="40px"
                    width="40px"

                  />
                </Upload>
                <div className={css.previewMask} onClick={replaceCoverHandler}>
                  <div className={css.maskText}>更换头像</div>
                </div>
              </div>
            </Col>
          )}
        </Row>
        <Row align="middle" justify="start" className={css.row}>
          <Col flex={'216px'}>真实姓名</Col>
          <Col flex={'auto'}>
            <span hidden={editMode}>{realName}</span>
            <Input
              hidden={!editMode}
              value={realName}
              onChange={onRealNameChange.bind(this)}
              placeholder="请输入真实姓名"
            />
          </Col>
        </Row>
        <Row align="top" justify="start" className={css.row}>
          <Col flex={'216px'}>个人简介</Col>
          {isUserLogin && (
            <Col flex={'auto'}>
              <span hidden={editMode}>
                {introduction ? introduction : '无'}
              </span>
              <Input.TextArea
                hidden={!editMode}
                value={introduction}
                rows={4}
                onChange={onIntroductionChange.bind(this)}
                placeholder="请输入个人简介"
              />
            </Col>
          )}
        </Row>
        <Row align="middle" justify="start" className={css.row}>
          <Col flex={'216px'}>性别</Col>
          {isUserLogin && (
            <Col flex={'auto'}>
              <span hidden={editMode}>{sexLabel ? sexLabel : '未设置'}</span>
              {editMode && (
                <Radio.Group onChange={onSexChange} value={sex}>
                  <Radio value={2} checked={sex == 2 ? true : false}>
                    男
                  </Radio>
                  <Radio value={3} checked={sex == 3 ? true : false}>
                    女
                  </Radio>
                </Radio.Group>
              )}
            </Col>
          )}
        </Row>

        <div className={css.fixdBtnContain}>
          <Button
            onClick={pwdChangeClick}
            type="default"
            hidden={!isUserLogin}
            className={`${css.btnStyle} ${css.btnDefault}`}
            style={{ marginRight: '25px' }}
          >
            修改密码
          </Button>
          <Button
            className={css.btnStyle}
            style={{ marginLeft: '25px' }}
            type="primary"
            hidden={!isUserLogin}
            onClick={() => {
              if (editMode) {
                updateUserInfo()
                setEditMode(false)
              } else {
                setEditMode(true)
              }
            }}
          >
            {editMode ? '保存' : '编辑'}
          </Button>
        </div>

        <ConfigProvider locale={zhCN}>
          <Modal
            title={
              <div
                style={{
                  width: '100%',
                  cursor: 'move',
                }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                修改密码
              </div>
            }
            className={css.ModalTip}
            open={pwdModalVisible}
            onOk={onOkToChangePwd}
            onCancel={handleCancel}
            modalRender={(modal) => (
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>
            )}
          >
            <Row justify="center" align="middle" className={css.row}>
              <Col flex={'76px'}>当前密码</Col>
              <Col flex={'230px'}>
                {' '}
                <Input
                  className={css.modalInput}
                  placeholder={'请输入当前密码'}
                  onChange={onCurrentPwdChange}
                  type={'password'}
                  maxLength={20}
                  minLength={6}
                />
              </Col>
            </Row>
            <Row justify="center" align="middle" className={css.row}>
              <Col flex={'76px'}>新密码</Col>
              <Col flex={'230px'}>
                {' '}
                <Input
                  className={css.modalInput}
                  placeholder={'请输入新密码，6-20位'}
                  onChange={onNewPwdChange}
                  type={'password'}
                  maxLength={20}
                  minLength={6}
                />
              </Col>
            </Row>
            <Row justify="center" align="middle" className={css.row}>
              <Col flex={'76px'}>确认密码</Col>
              <Col flex={'230px'}>
                {' '}
                <Input
                  className={css.modalInput}
                  placeholder={'请再次输入新密码'}
                  onChange={onNewPwdConfirmChange}
                  type={'password'}
                  maxLength={20}
                  minLength={6}
                />
              </Col>
            </Row>
          </Modal>
        </ConfigProvider>
      </Card>
  )
}

export default MyBasicInfo
